// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"0734ffe4","251":"76b17772","348":"d23358b0","571":"97db3660"}[chunkId] + ".chunk.js";
};